/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';

import FileModel from '../../../../models/FileModel';
import FileActions from '../../../appAuthorized/redux/FileActions';
import FilePickerRow from './FilePickerRow';

import RouteNames from '../../../appAuthorized/RouteNames';
import { isMobileApplication } from '../../../../utilities/MobileUtil';
import { IconAddFile } from '../../../components/addIcons';
import { navigate } from '../../../appAuthorized/redux/NavigationActions';

import './AddFileButton.styles.scss';

interface Props {
  selectFile?(file): void;
  openMobileModal(): void;
}

function mapStateToProps(): Partial<Props> {
  return {
    selectFile: rawFile => {
      const newFile = FileModel.createFromRawFile(rawFile);

      if (newFile.isTooBig()) {
        navigate(RouteNames.fileUploadError());
      } else {
        FileActions.rawFileSelected(rawFile);
        navigate(RouteNames.fileUpload());
      }
    },
  };
}

@connect(mapStateToProps)
export class AddFileButton extends React.Component<Props, {}> {
  handleClick = (e) => {
    e.stopPropagation();
    this.props.openMobileModal();
  }

  render() {
    if (isMobileApplication()) {
      // open either popup
      return (
        <div className="cmp-add-file-button" onClick={this.handleClick}>
          <IconAddFile/>
        </div>
      );
    } else {
      // file picker
      return (
        <div className="cmp-add-file-button" onClick={(e) => e.stopPropagation()}>
          <FilePickerRow
            name="fileSelection"
            onChange={this.props.selectFile}
          >
            <IconAddFile/>
          </FilePickerRow>
        </div>
      );
    }
  }
}
